function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import { definePropType } from "@types-vue/props";
import { getPackItems, getPackUnit, isMaxStorage, transformPayload } from "./utils";
import { UsageType } from "@com/enums/user";
import { STORAGE, MIN_DOWNLOAD_PUSH_COUNT, DOWNLOAD_PUSH_COUNT_STEP } from "./config";
import TableList from "@pt/views/pt-entry/components/table-list.vue";
import { calOrderCost } from "@pt/api/grant";
import _ from "lodash";
import TotalFooter from "./total-footer.vue";
import { t } from "@/lang";
import { isCNSuffix } from "@com/utils/url";
export default defineComponent({
    name: "PackTable",
    props: {
        userInfo: {
            type: definePropType(Object),
            required: true
        },
        enabled: Boolean
    },
    components: {
        TableList: TableList,
        TotalFooter: TotalFooter
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        var getPackItemName = function getPackItemName(item) {
            switch(item.usage_type){
                case UsageType.DownloadPush:
                    return t("playTurbo.payment.grantDialog.packTable.downloadPush");
                case UsageType.RenderVideo:
                    return t("playTurbo.payment.grantDialog.packTable.renderVideo");
                case UsageType.Storage:
                    return t("playTurbo.payment.grantDialog.packTable.storageUpgrade", {
                        storage: STORAGE
                    });
                default:
                    return "";
            }
        };
        // 总价
        var totalAmount = ref(0);
        var loading = ref(false);
        // 如果存储空间已经是200G，就不展示存储空间升级的选项
        var showStorage = computed(function() {
            return !isMaxStorage(props.userInfo.storage.total_size);
        });
        var currency = computed(function() {
            return isCNSuffix() ? "CNY" : "USD";
        });
        var packItems = ref(getPackItems());
        var packListColumnConfig = [
            {
                prop: "name",
                label: t("playTurbo.payment.grantDialog.packTable.name"),
                align: "left",
                params: {
                    innerHTML: function(param) {
                        var row = param.row;
                        return getPackItemName(row);
                    }
                }
            },
            {
                prop: "price",
                slot: "price"
            },
            {
                prop: "count",
                slot: "count"
            },
            {
                prop: "amount",
                slot: "amount"
            },
            {
                prop: "slot",
                label: "",
                width: 16,
                params: {
                    innerHTML: function() {
                        return "";
                    }
                }
            }, 
        ];
        function getPackOrderCost(payload) {
            return _getPackOrderCost.apply(this, arguments);
        }
        function _getPackOrderCost() {
            _getPackOrderCost = /** 获取加量项的已选价格 */ _asyncToGenerator(regeneratorRuntime.mark(function _callee(payload) {
                var res, data;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            loading.value = true;
                            Object.values(packItems.value).forEach(function(item) {
                                if (!item.enabled) {
                                    item.count = 0;
                                }
                            });
                            _ctx.next = 4;
                            return calOrderCost({
                                payload: payload
                            }).finally(function() {
                                loading.value = false;
                            });
                        case 4:
                            res = _ctx.sent;
                            if (res.data.code === 0) {
                                data = res.data.data;
                                Object.values(packItems.value).forEach(function(item) {
                                    Object.assign(item, data.items[item.usage_type]);
                                });
                                totalAmount.value = data.total_amount;
                            }
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getPackOrderCost.apply(this, arguments);
        }
        var debounceGetPackOrderCost = _.debounce(function(payload) {
            return getPackOrderCost(payload);
        }, 300);
        var handleCountChange = function(item) {
            if (item.count === 9) {
                item.count = 0;
            } else if (item.count === 1) {
                item.count = 10;
            }
        };
        watch(packItems, function() {
            emit("change", packItems.value);
        }, {
            deep: true
        });
        // 监听数据，计算加油包订单金额
        watch(function() {
            return Object.values(packItems.value).map(function(item) {
                return item.count;
            }).join(",");
        }, function() {
            if (props.enabled) {
                debounceGetPackOrderCost(transformPayload(packItems.value, !showStorage.value));
            }
        });
        //
        onMounted(function() {
            // 第一次全部传0，为了知道哪些可购买哪些不行
            if (props.enabled) {
                var _obj;
                getPackOrderCost((_obj = {}, _defineProperty(_obj, UsageType.DownloadPush, 0), _defineProperty(_obj, UsageType.Storage, 0), _defineProperty(_obj, UsageType.RenderVideo, 0), _obj)).finally(function() {
                    if (packItems.value[UsageType.Storage].count === 0) {
                        packItems.value[UsageType.Storage].count = packItems.value[UsageType.Storage].quantity;
                    }
                });
            }
        });
        return {
            UsageType: UsageType,
            packListColumnConfig: packListColumnConfig,
            packItems: packItems,
            totalAmount: totalAmount,
            MIN_DOWNLOAD_PUSH_COUNT: MIN_DOWNLOAD_PUSH_COUNT,
            DOWNLOAD_PUSH_COUNT_STEP: DOWNLOAD_PUSH_COUNT_STEP,
            currency: currency,
            getPackUnit: getPackUnit,
            getPackItemName: getPackItemName,
            handleCountChange: handleCountChange
        };
    }
});
